:host {
  --aha-panel--border-radius: 6px;

  display: block;
  border: 1px solid var(--theme-primary-border);
  border-radius: var(--aha-panel--border-radius);
  background-color: var(--theme-primary-background);
}

:host([boxshadow='true']) {
  box-shadow: 0px 0px 8px rgb(0 0 0 / 8%);
}

#header {
  border-bottom: 1px solid var(--theme-primary-border);
}

#header,
#main {
  padding: 13px 24px;
}

#heading,
slot[name='heading']::slotted(h1),
slot[name='heading']::slotted(h2),
slot[name='heading']::slotted(h3),
slot[name='heading']::slotted(h4),
slot[name='heading']::slotted(h5),
slot[name='heading']::slotted(h6) {
  font-size: 18px !important;
  font-weight: 700 !important;
  margin: 0;
  padding: 0;
}
